import styled from 'styled-components'
import ScrollContainer from 'react-indiana-drag-scroll'

export const _ListingRow = styled(ScrollContainer)`
  width: 100%;
  padding-top: 10px;
  display: flex;
  margin: 0;
  overflow-x: auto !important;

  > div {
    &:first-child {
      margin-left: 0;
    }
  }
`
